module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "actioninfo",
    attrs: {
      "id": "ACTIONINFO-SWF"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.mask_visible),
      expression: "mask_visible"
    }],
    staticClass: "mask"
  }), _vm._v(" "), _c('div', {
    staticClass: "option"
  }, [_c('div', {
    staticClass: "item"
  }, [_c('el-checkbox', {
    on: {
      "change": _vm.handleChangeFinality
    },
    model: {
      value: (_vm.finality),
      callback: function($$v) {
        _vm.finality = $$v
      },
      expression: "finality"
    }
  }, [_vm._v("全身动作")])], 1), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('el-checkbox', {
    on: {
      "change": _vm.handleChangeLooped
    },
    model: {
      value: (_vm.looped),
      callback: function($$v) {
        _vm.looped = $$v
      },
      expression: "looped"
    }
  }, [_vm._v("循环动作")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "slider"
  }, [_c('div', {
    staticClass: "text1",
    class: {
      active: _vm.looped
    },
    staticStyle: {
      "color": "#e2e2e2"
    }
  }, [_vm._v(_vm._s("移动速度：" + ((_vm.looped_value == undefined || _vm.looped_value == NaN) ? 0 : (_vm.looped_value / 100).toFixed(2))))]), _vm._v(" "), _c('span', {
    staticClass: "l"
  }, [_vm._v("0")]), _vm._v(" "), _c('span', {
    staticClass: "r"
  }, [_vm._v("1")]), _vm._v(" "), _c('el-slider', {
    staticStyle: {
      "-webkit-transform": "scale(0.55)",
      "width": "300px",
      "left": "-70px",
      "position": "relative"
    },
    attrs: {
      "format-tooltip": _vm.formatTooltip,
      "disabled": !_vm.looped
    },
    on: {
      "change": function($event) {
        return _vm.handleChangeSliderOption(_vm.looped_value)
      }
    },
    model: {
      value: (_vm.looped_value),
      callback: function($$v) {
        _vm.looped_value = $$v
      },
      expression: "looped_value"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "text2"
  }, [_vm._v("0表示不可移动")])], 1), _vm._v(" "), _c('div', {
    staticClass: "tip"
  }, [_c('span', {
    staticClass: "l"
  }, [_c('span', [_vm._v("NEXT动作：")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.next.length > 10 ? _vm.next.substring(0, 10) + '...' : _vm.next))]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.next != '无'),
      expression: "next != '无'"
    }],
    staticClass: "el-icon-close",
    staticStyle: {
      "width": "25px",
      "height": "25px",
      "margin-left": "5px",
      "margin-top": "-2px"
    },
    on: {
      "click": _vm.handleActionHide
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "r"
  }, [_c('div', {
    staticClass: "button",
    staticStyle: {
      "font-size": "12px",
      "top": "-5px",
      "position": "relative"
    },
    on: {
      "click": _vm.handleActionShow
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "60px",
      "height": "20px",
      "font-size": "12px",
      "padding": "2px 2px 2px 2px",
      "border-radius": "4px",
      "font-family": "PingFangSC-Regular"
    },
    attrs: {
      "type": "warning",
      "size": "small"
    }
  }, [_vm._v("选择动作")])], 1)])]), _vm._v(" "), (_vm.platform == 'qt') ? _c('psocket', {
    attrs: {
      "attributes": _vm.attributes,
      "flashvars": _vm.flashvars
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b7997d46","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ActionInfo/ActionInfo.vue
// module id = 405
// module chunks = 0